export default "__VITE_ASSET__BpdgyRPU__"